var image_viewer_rtlignore_default = {
  "fontElementMap": "cZM6Q",
  "imageContainer": "_8jXxT",
  "expandContainer": "_3r1-q",
  "expandIcon": "ZkEJy",
  "pointer": "J5XSD",
  "imageWrapper": "_3EYSQ",
  "imageRatio": "_1b9c4",
  "image": "B1wkR",
  "imageOverlay": "dI0AB",
  "imageCaption": "_9Eiil",
  "imagePreload": "tMsNj",
  "imageHighres": "CIC-w",
  "onlyHighRes": "fl-Vg",
  "image_loading": "p7Yl5"
};
export {
  image_viewer_rtlignore_default as default
};
//# sourceMappingURL=image-viewer.rtlignore-scss.js.map
